const MEXICO_TZ = 'America/Mexico_City';

// Mexico Central is fixed UTC-6 year-round (no DST since 2022), but we
// resolve it via Intl instead of hardcoding the offset so any future policy
// change is picked up automatically. `Date.prototype.toISOString()` always
// renders UTC, which silently jumps to the next calendar day between 18:00
// and 23:59 Mexico time — this is what "today"/"tomorrow" must go through
// instead everywhere the app means the Mexico calendar day, not the UTC one.
export function getMexicoDateString(date: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: MEXICO_TZ }).format(date);
}

// dateStr is a plain YYYY-MM-DD (no time component), so arithmetic is done
// on its UTC-midnight representation — unambiguous, no timezone to resolve.
export function addDaysToDateString(dateStr: string, days: number): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  return dt.toISOString().split('T')[0];
}

export function getMexicoTomorrowString(date: Date = new Date()): string {
  return addDaysToDateString(getMexicoDateString(date), 1);
}

// "YYYY-MM-DDTHH:MM" in Mexico wall-clock time, the format <input
// type="datetime-local"> expects and displays verbatim (no timezone
// conversion happens in the browser for that input type).
export function getMexicoDateTimeLocalString(date: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: MEXICO_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const get = (type: string) => parts.find(p => p.type === type)!.value;
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
}
